<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
              name="Settlement"
              bc1="App"
              bc2="Aggregate"
              bc3="Create"
          ></Breadcrumb>
        </div>
        <div class="col-3">
          <div class="d-flex align-items-center justify-content-end">
            <button
                type="button"
                class="btn btn-gradient-danger btn-sm"
                @click="$router.back()"
            >
              <span class="text-nowrap">Back</span>
            </button>
          </div>
        </div>
        <div
            class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
        </div>
      </div>
      <div class="content-body">
        <!-- Basic Horizontal form layout section start -->
        <section id="basic-horizontal-layouts">
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Generate Settlement</h4>
                </div>
                <div class="card-body">
                  <form class="form form-horizontal">
                    <div class="row">
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Select Payment Method</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <div v-if="paymentMethodLoader" class="col-12 d-flex mt-2  justify-content-center">
                                <div class="spinner-border spinner-border-sm  text-primary"></div>
                              </div>
                              <select
                                  v-else
                                  class="form-control"
                                  v-model="selectedPaymentMethod"
                              >
                                <option :value="null">Select Payment Method</option>
                                <option
                                    :key="paymentMethod.id"
                                    :value="paymentMethod"
                                    v-for="paymentMethod in paymentMethods"
                                >
                                  {{ paymentMethod.name + ' - ' + paymentMethod.code }}
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Select Merchant</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <SearchSelect
                                  v-model="selectedMerchant"
                                  url="v1/get-merchants"
                                  :filterParams="{ flag: 'all' }"
                                  :customLabelFn="customNameForMultiselect"
                                  placeholder="Search Merchant..."
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                        <div class="col-12">
                          <div class="form-group row">
                            <div class="col-sm-3 col-form-label">
                              <label>Settlements For Account</label>
                            </div>
                            <div class="col-sm-9">
                              <div class="input-group">
                                <div class="custom-control custom-switch">
                                  <input
                                      type="checkbox"
                                      class="custom-control-input"
                                      id="settlementForAccount"
                                      v-model="settlementForAccount"
                                  />
                                  <label
                                      class="custom-control-label"
                                      for="settlementForAccount"
                                  >
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Select Account</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <select
                                  class="form-control"
                                  v-model="selectedMerchantDetails"
                              >
                                <option
                                    :key="merchantDetailsIndex"
                                    :value="merchantDetails"
                                    v-for="(merchantDetails, merchantDetailsIndex) in MerchantDetailsData"
                                >
                                  {{ merchantDetails.account_title + ' / ' + merchantDetails.currency.code }}
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12" v-if="!settlementForAccount">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Settlement For Store</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <div class="custom-control custom-switch">
                                <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="settlementForStore"
                                    v-model="settlementForStore"
                                />
                                <label
                                    class="custom-control-label"
                                    for="settlementForStore"
                                >
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12" v-if="!settlementForAccount">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Select Store <span v-if="settlementForStore" class="text-danger">*</span></label>
                          </div>
                          <div class="col-sm-9">
                            <InfiniteSelect
                                api-url="v1/get-store"
                                ref="storeInfiniteSelect"
                                :request-params="requestParams"
                                :formatter="customStoreNameForMultiselect"
                                key-field="id"
                                @selectedFullObj="handleStoreSelected"
                                placeholder-text="Select a store..."
                            />
                            <small v-if="storeError" class="text-danger">*Store is required when settlement is for store</small>
                          </div>
                        </div>
                      </div>
                      <div class="col-12" v-if="!settlementForAccount && !settlementForStore">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Select Terminal</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <multiselect
                                  v-model="selectedTerminal"
                                  :options="terminalData"
                                  label="label"
                                  track-by="id"
                                  placeholder="Select Terminal"
                                  :loading="terminalLoader"
                                  variant="primary"
                                  :custom-label="customStoreNameForMultiselect"
                              ></multiselect>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12" v-if="!settlementForAccount && !settlementForStore">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Select Channel</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <multiselect
                                  v-model="selectedChannel"
                                  :options="channelData"
                                  label="label"
                                  track-by="id"
                                  placeholder="Select Channel"
                                  :loading="channelLoader"
                                  variant="primary"
                                  :custom-label="customStoreNameForMultiselect"
                              ></multiselect>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Start Date</label>
                          </div>
                          <div class="col-sm-9">
                            <date-picker
                                v-model="fromDate"
                                :disabledDate="disableFutureDates"
                                valueType="format"
                                :lang="lang"
                                name="fromDate"
                                placeholder="choose starting date"
                            ></date-picker>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>End Date</label>
                          </div>
                          <div class="col-sm-9">
                            <date-picker
                                v-model="toDate"
                                :disabledDate="disableFutureDates"
                                valueType="format"
                                :lang="lang"
                                name="toDate"
                                placeholder="choose ending date"
                            ></date-picker>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-9 offset-sm-3">
                        <button type="button" class="btn btn-primary mr-1" @click="generateSettlement">Generate</button>
                      </div>
                    </div>
                  </form>
                  <div class="row  float-right" v-if="!isEmpty(filteredData)">
                    <button type="button" class="btn btn-sm btn-warning m-1" @click="showSkipped = !showSkipped">
                      {{ showSkipped ? 'Hide Skipped' : 'Show Skipped' }}
                    </button>
                  </div>
                  <div class="row mt-5 w-100" v-if="!isEmpty(filteredData)" v-show="!showSkipped">
                    <div class="col-12">
                      <div class="">
                        <CommonTable
                            :url="url"
                            :tableHeaderValues="tableHeaderValues"
                            :actions="actions"
                            :deleteActions="deleteActions"
                            :mutedData="mutedData"
                            :storageKey="storageKey"
                            :externalTotalRecord="externalTotalRecord"
                            :filteredData="filteredData"
                            @getFullResponse="getFullResponse"
                            :loadMore="true"

                        />
                      </div>
                    </div>
                  </div>
                  <div class="row mt-5 w-100" v-if="!isEmpty(filteredData)" v-show="showSkipped">
                    <div class="col-12">
                      <div class="">
                        <div class="card-datatable table-responsive pt-0">
                          <table class="user-list-table table">
                            <thead class="thead-light">
                            <tr>
                              <th>TRANSACTION ID</th>
                              <th>Gateway Reference</th>
                              <th>SENDER ACCOUNT TITLE</th>
                              <th>Sender Account Num</th>
                              <th>Actual Amount</th>
                              <th>Vat</th>
                              <th>Fees</th>
                              <th>Payable Amount</th>
                              <th>Transaction Time/Date <span class="text-warning font-weight-bolder">(Showing In GMT)</span></th>
                              <th>
                                Actions
                              </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(skippedRow,skippedIndex) in skippedData" :key="skippedIndex">
                              <td>{{ skippedRow.uuid }}</td>
                              <td>{{ skippedRow.gateway_reference_id }}</td>
                              <td>{{ skippedRow.sender_account_number }}</td>
                              <td>{{ skippedRow.sender_account_title }}</td>
                              <td>{{ parseFloat(skippedRow.amount / 100).toFixed(amountDecimalPlaces) }}&nbsp<div class="badge badge-light-success">{{selectedMerchantDetails ? selectedMerchantDetails.currency.code : ''}}</div></td>
                              <td>{{ parseFloat(skippedRow.vat / 100).toFixed(feesDecimalPlaces) }}&nbsp<div class="badge badge-light-success">{{selectedMerchantDetails ? selectedMerchantDetails.currency.code : ''}}</div></td>
                              <td>{{ parseFloat(skippedRow.fee / 100).toFixed(feesDecimalPlaces) }}&nbsp<div class="badge badge-light-success">{{selectedMerchantDetails ? selectedMerchantDetails.currency.code : ''}}</div></td>


                              <td v-if="skippedRow.transaction_type_id == 6">
                                <span style="font-size: larger"
                                      class=" font-weight-bolder text-danger row justify-content-center">- {{
                                    parseFloat((parseFloat(skippedRow.amount)+parseFloat(skippedRow.vat)+parseFloat(skippedRow.fee))/100).toFixed(amountDecimalPlaces)
                                  }}</span>
                                <div class="row text-center">
                                  <div class="col-12">
                                    <div class="badge badge-light-success">{{selectedMerchantDetails ? selectedMerchantDetails.currency.code : ''}}</div>
                                  </div>
                                </div>
                                <div class="row text-center">
                                  <div class="col-12">
                                    <div class="badge badge-light-danger mt-1">Refunded</div>
                                  </div>
                                </div>
                                <div v-if="skippedRow.refunded_transaction" class="badge badge-light-info mt-1">{{skippedRow.refunded_transaction.uuid}}</div>
                              </td>
                              <td v-else-if="(skippedRow.transaction_type_id == 11 || skippedRow.transaction_type_id == 15) && selectedMerchantDetails.id == skippedRow.sender_account_id ">
                                <span style="font-size: larger"
                                      class=" font-weight-bolder text-danger row justify-content-center">- {{
                                    parseFloat((parseFloat(skippedRow.amount)+parseFloat(skippedRow.vat)+parseFloat(skippedRow.fee))/100).toFixed(amountDecimalPlaces)
                                  }}</span>
                                <div class="row text-center">
                                  <div class="col-12">
                                    <div class="badge badge-light-success">{{selectedMerchantDetails ? selectedMerchantDetails.currency.code : ''}}</div>
                                  </div>
                                </div>
                                <div class="row text-center">
                                  <div class="col-12">
                                    <div class="badge badge-light-primary mt-1">{{skippedRow.transaction_type_id == 11 ? 'Adjusted' : 'R-Reserved'}}</div>
                                  </div>
                                </div>
<!--                                <div v-if="skippedRow.refunded_transaction" class="badge badge-light-info mt-1">{{skippedRow.refunded_transaction.uuid}}</div>-->
                              </td>
                              <td v-else>
                                {{
                                  (parseFloat((skippedRow.amount - skippedRow.vat - skippedRow.fee) / 100).toFixed(amountDecimalPlaces))
                                }}
                                <div class="badge badge-light-success">{{selectedMerchantDetails ? selectedMerchantDetails.currency.code : ''}}</div>
                              </td>
                              <td>{{new Date(skippedRow.created_at).toISOString().slice(0, 16).replace('T', ' ') }}
                              </td>
                              <td class="d-flex">
                                <button class="btn btn-sm  ml-1 btn-warning " @click="unSkip(skippedRow,skippedIndex)">
                                  Unskip
                                </button>
                              </td>
                            </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-5 ml-2" v-if="!isEmpty(filteredData)">
                    <button
                        @click="showModalForConfirmButton = true"
                        type="button"
                        class="btn btn-primary mr-1 d-flex"
                        :disabled="loading"
                    >
                      <Loader :loading="loading" :size="size"></Loader>
                      Confirm
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section v-if="!isEmpty(filteredData)">
          <div class="row ">
            <div class="col-md-12 col-12 ">
              <div class="card border-primary badge-glow">
                <div class="card-header">
                  <h4 class="card-title">Settlement Details</h4>
                </div>
                <div class="card-body">
                  <div class="row ">
                    <div class="col-12">
                      <div class="form-group row">
                        <div class="col-sm-3">
                          <p class="text-dark font-weight-bolder">Payable Amount</p>
                        </div>
                        <div class="col-sm-9">
                          <div class="input-group">
                            <p class="text-warning font-weight-bolder">{{modifyAmount(parseFloat(settlementDetails.paybleAmount / 100).toFixed(amountDecimalPlaces)) }}</p>
                          </div>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-sm-3">
                          <p class="text-dark font-weight-bolder">Settlement Charges</p>
                        </div>
                        <div class="col-sm-9">
                          <div class="input-group">
                            <p class="text-danger font-weight-bolder">{{ parseFloat(settlementDetails.charges / 100).toFixed(feesDecimalPlaces) }}</p>
                          </div>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-sm-3">
                          <p class="text-dark font-weight-bolder">Vat</p>
                        </div>
                        <div class="col-sm-9">
                          <div class="input-group">
                            <p class="text-danger font-weight-bolder">{{ parseFloat(settlementDetails.vat / 100).toFixed(feesDecimalPlaces) }}</p>
                          </div>
                        </div>
                      </div>
                      <div class="form-group row" v-if="rollingReserveDetails != null">
                        <div class="col-sm-3">
                          <p class="text-dark font-weight-bolder">Reserve (%)</p>
                        </div>
                        <div class="col-sm-9">
                          <div class="input-group">
                            <p class="text-dark font-weight-bolder">
                              {{
                                  rollingReserveDetails.reserve +'%'
                              }}<span class="text-info">{{reserve == 0 ? ' (Not Applicable)' : ''}}</span></p>
                          </div>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-sm-3">
                          <p class="text-dark font-weight-bolder">Settlement Amount Before Reserve</p>
                        </div>
                        <div class="col-sm-9">
                          <div class="input-group">
                            <p class="text-success font-weight-bolder">
                              {{
                               modifyAmount( settlementBeforeReserve =   parseFloat((parseFloat(settlementDetails.paybleAmount) - parseFloat(settlementDetails.vat) - parseFloat(settlementDetails.charges)) / 100).toFixed(amountDecimalPlaces))
                              }}</p>
                          </div>
                        </div>
                      </div>
                      <div class="form-group row" v-if="rollingReserveDetails != null">
                        <div class="col-sm-3">
                          <p class="text-dark font-weight-bolder">Reserve (Amount)</p>
                        </div>
                        <div class="col-sm-9">
                          <div class="input-group">
                            <p class="text-danger font-weight-bolder">
                              {{
                               modifyAmount(reserve = parseFloat(((parseFloat(settlementBeforeReserve))*((parseFloat(rollingReserveDetails.reserve))/100))) > 0 ? parseFloat(((parseFloat(settlementBeforeReserve))*((parseFloat(rollingReserveDetails.reserve))/100))) : 0)
                              }}</p>
                          </div>
                        </div>
                      </div>
                      <div class="form-group row" v-if="rollingReserveDetails != null">
                        <div class="col-sm-3">
                          <p class="text-dark font-weight-bolder">Settlement Amount After Reserve</p>
                        </div>
                        <div class="col-sm-9">
                          <div class="input-group">
                            <p class="text-success font-weight-bolder">
                              {{
                                  modifyAmount(parseFloat(settlementBeforeReserve) -  parseFloat(reserve))
                              }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <ConfirmationModal :show="showConfirmationModal" @confirm="confirm" message="Are you sure to skip the settlement?"
                       title="Skip Settlement"
                       @hide="showConfirmationModal = false"></ConfirmationModal>

    <ConfirmationModal :show="showModalForConfirmButton" @confirm="confirmCreate" message="Are you sure to create the settlement?"
                       title="Create Settlement"
                       @hide="showModalForConfirmButton = false"></ConfirmationModal>

  </div>
  <!-- END: Content-->
</template>


<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import SearchSelect from "@/components/common/SearchSelect.vue";
import InfiniteSelect from "@/components/common/InfiniteSelect.vue";

export default {
  components: {
    InfiniteSelect,
    SearchSelect,
    DatePicker
  },
  mounted() {


    localStorage.setItem("url", "v1/get-settlement-transactions");
    this.checkDataInStore('v1/get-settlement-transactions')
    if (
        typeof this.$route.params.update == "undefined" &&
        typeof this.$route.params.add == "undefined"
    ) {
      this.$store.dispatch("set", null);
    }

    this.getPaymentMethods()

    // this.getMerchantData()


  },
  data() {
    return {
      size: "10px",
      loading: false,
      rollingReserveDetails:null,
      reserve:0,
      settlementBeforeReserve:0,
      showConfirmationModal: false,
      showModalForConfirmButton: false,
      charges: '',
      paybleAmount: '',
      loader: false,
      currencyLoader: true,
      emailOrPhone: '',
      selectedCurrency: null,
      currencyData: [],
      fromDate: null,
      toDate: null,
      transactionTypes: [],
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
        monthBeforeYear: false,
      },
      url: "",
      storageKey: "create-aggregate-settlement",
      status: "",
      filteredData: {},
      tableHeaderValues: [
        {
          title: 'Transaction Id',
          valueKey: 'uuid',
          html: true,
          alter: function (value) {
            var html = ''
            if (value)
              html = `<span class="text-primary">${value}</span>`


            return html


          }
        },
        {
          title: 'Gateway Reference',
          valueKey: 'gateway_reference_id',
          html: true,
          alter: function (value) {
            var html = ''
            if (value)
              html = `<span class="text-info">${value}</span>`


            return html


          }
        },
        {
          title: 'Sender Account Title',
          valueKey: 'sender_account_title',
          html: true,
          alter: function (value) {
            var html = ''
            html = ` <a href="javascript:void()" class="badge badge-glow badge-dark">${value}</a>`

            return html


          }
        },
        {
          title: 'Sender Account Num',
          valueKey: 'sender_account_number',
        },
        {
          title: 'Channel',
          valueKey: 'channel',
          html: true,
          alter: function (value) {
            // Show the channel name when the transaction carries a channel object
            return value && value.name
                ? `<p class="text-primary mb-0">${value.name}</p>`
                : '-'
          }
        },
        {
          title: 'Actual Amount',
          valueKey: 'amount',
          html: true,
          alter: (value, row) => {
            var html = ''
            if (value)
              html = `<div  class="font-lg-4 font-weight-bolder text-dark">${this.modifyAmount(parseFloat(value / 100).toFixed(this.amountDecimalPlaces))}</div>&nbsp<div class="badge badge-light-success">${this.selectedMerchantDetails ? this.selectedMerchantDetails.currency.code : ''}</div>`


            return html


          }
        },
        {
          title: 'Vat',
          valueKey: 'vat',
          html: true,
          alter: (value, row) => {
            var html = ''

            html = ` <div  class="  text-dark">${parseFloat(value / 100).toFixed(this.feesDecimalPlaces)}</div>&nbsp<div class="badge badge-light-success">${this.selectedMerchantDetails ? this.selectedMerchantDetails.currency.code : ''}</div>`


            return html
          }
        },
        {
          title: 'Fees',
          valueKey: 'fee',
          html: true,
          alter: (value, row) => {
            var html = ''

            html = ` <div  class="  text-dark">${parseFloat(value / 100).toFixed(this.feesDecimalPlaces)}</div>&nbsp<div class="badge badge-light-success">${this.selectedMerchantDetails ? this.selectedMerchantDetails.currency.code : ''}</div>`


            return html

          }
        },
        {
          title: 'Payable Amount',
          valueKey: 'amount',
          html: true,
          customClass: 'text-center',
          alter: (value, row) => {
            var html = ''
            if (value) {
              if (row.transaction_type_id == 6) {
                html = `<span style="font-size: larger" class=" font-weight-bolder text-danger row justify-content-center">- ${this.modifyAmount(parseFloat((parseFloat(value)+parseFloat(row.vat)+parseFloat(row.fee))/100).toFixed(this.amountDecimalPlaces))}</span>
                <div class="row">
                <div class="col-12">
                <div class="badge badge-light-success">${this.selectedMerchantDetails ? this.selectedMerchantDetails.currency.code : ''}</div>
                </div>
                </div>
                <div class="row">
                <div class="col-12">
                <div class="badge badge-light-danger mt-1">Refunded</div>
                </div>
                </div>
                `
                if (row.refunded_transaction)
                  html += `<div class="badge badge-light-info mt-1">${row.refunded_transaction.uuid}</div>`
              }
              else if ((row.transaction_type_id == 11 || row.transaction_type_id == 15) && this.selectedMerchantDetails.id == row.sender_account_id  ) {
                html = `<span style="font-size: larger" class=" font-weight-bolder text-danger row justify-content-center">- ${this.modifyAmount(parseFloat((parseFloat(value)+parseFloat(row.vat)+parseFloat(row.fee))/100).toFixed(this.amountDecimalPlaces))}</span>
                <div class="row">
                <div class="col-12">
                <div class="badge badge-light-success">${this.selectedMerchantDetails ? this.selectedMerchantDetails.currency.code : ''}</div>
                </div>
                </div>
                <div class="row">
                <div class="col-12">
                <div class="badge badge-light-primary mt-1">${row.transaction_type_id == 11 ? 'Adjusted' : 'R-Reserved'}</div>
                </div>
                </div>
                `
                if (row.refunded_transaction)
                  html += `<div class="badge badge-light-info mt-1">${row.refunded_transaction.uuid}</div>`
              }
              else {

                html = `<span style="font-size: larger" class=" font-weight-bolder text-dark">${this.modifyAmount(parseFloat((value - row.vat - row.fee) / 100).toFixed(this.amountDecimalPlaces))}</span>&nbsp<div class="badge badge-light-success">${this.selectedMerchantDetails ? this.selectedMerchantDetails.currency.code : ''}</div>`

              }
            }


            return html


          },
        },
        {
          title: 'Transaction Time/Date',
          titleHtml: `<span class="text-warning font-weight-bolder">
														(Showing In GMT)
													</span>`,
          valueKey: "created_at",
          html: true,
          alter: (value,row) => {
            var html='-'
            if(value)
              html = ` <div  class=" font-weight-bolder text-dark">${new Date(value).toISOString().slice(0, 16).replace('T', ' ')}</div>`



            return  html


          }
        },
      ],
      actions: [{
        title: 'Skip',
        class: 'btn-warning ',
        cta: (row, index) => {
          this.tempMutedData = {
            index: index,
            delete: row.id,
            row: row
          }
          this.showConfirmationModal = true
        },

      },],
      deleteActions: [],
      mutedData: [],
      externalTotalRecord: "",
      selectedMerchant: null,
      selectedStore: null,
      selectedTerminal: null,
      selectedChannel: null,
      selectedPaymentMethod: null,
      paymentMethods: [],
      paymentMethodLoader: false,
      MerchantsData: [],
      storeData: [],
      terminalData: [],
      channelData: [],
      terminalLoader:false,
      channelLoader:false,
      MerchantDetailsData: [],
      selectedMerchantDetails: null,
      showTable: false,
      tempMutedData: [],
      createSettlementTransactions: [],
      skippedData: [],
      settlementDetails: {
        charges: '',
        paybleAmount: '',
        vat: '',
        chargesDetails: []
      },
      settlementData: '',
      showSkipped: false,
      requestParams: {},
      settlementForAccount: false,
      settlementForStore: false,
      storeError: false


    }
  },
  methods: {
    handleStoreSelected(item) {
      this.selectedStore = item
    },
    customNameForMultiselect({ email, first_name, business_name }) {
      const nameToUse = business_name === null || business_name === '' ? first_name : business_name;
      return `${email}/${nameToUse}`;
    },
    customStoreNameForMultiselect ({ name,code }) {
      return `${name}/${code}`
    },
    createSettlement() {
      this.loading = true
      let data = {settlementData: this.settlementData}
      this.createSettlementTransactions = []
      if (this.skippedData.length) {
        this.skippedData.forEach(eachskippedData => {
          this.createSettlementTransactions.push(eachskippedData.uuid)
        })
      }
      data.transactions = JSON.stringify(this.createSettlementTransactions)
      this.makeRequest("post", "v1/add-settlement", data).then(
          (callResponse) => {
            this.loading = false
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              let responseData = callResponse.response.data.data;
              if (code == 200) {
                this.$router.push({name: 'aggregator-settlements'})
              }
            }
          }
      );
    },
    unSkip(row, index) {
      this.skippedData.splice(index, 1);
      this.mutedData = {
        pushRow: true,
        row: row
      }

      if (row.transaction_type_id != 6) {

        if((row.transaction_type_id == 11 || row.transaction_type_id == 15) && this.selectedMerchantDetails.id == row.sender_account_id){
          /*if adjustment amount then on unskip revert it and minus from total payable amount*/
          let amountToBeDeduct = parseFloat(row.amount) + parseFloat(row.vat) + parseFloat(row.fee)
          this.settlementDetails.paybleAmount = this.settlementDetails.paybleAmount - amountToBeDeduct
        }else{
          /*if row is unskipped then add the amount of row to total payable amount*/
          let amountToBeAdded =  parseFloat(row.amount) - parseFloat(row.vat) - parseFloat(row.fee)
          this.settlementDetails.paybleAmount = this.settlementDetails.paybleAmount + amountToBeAdded
        }




      }else{
        /*if refund amount then on unskip revert it and minus from total payable amount*/
        let amountToBeDeduct = parseFloat(row.amount) + parseFloat(row.vat) + parseFloat(row.fee)
        this.settlementDetails.paybleAmount = this.settlementDetails.paybleAmount - amountToBeDeduct
      }
      let tempVatChargeDataFromChargesDetails = ''
      let tempTotalPercentChargesDataFromChargesDetails = 0
      let tempTotalFixedChargesDataFromChargesDetails = 0

      Object.values(this.settlementDetails.chargesDetails).forEach(eachChargeDetail => {
        if (eachChargeDetail.charge_type != 'VAT') {
          if (eachChargeDetail.type == 'percent') {
            tempTotalPercentChargesDataFromChargesDetails += parseFloat(eachChargeDetail.charges)
          } else {
            tempTotalFixedChargesDataFromChargesDetails += parseFloat(eachChargeDetail.charges)
          }
        } else {
          /*if charge type is vat then save for later use after the final charge has bee calculated*/
          tempVatChargeDataFromChargesDetails = eachChargeDetail
        }
      })

      this.settlementDetails.charges = this.settlementDetails.paybleAmount * (tempTotalPercentChargesDataFromChargesDetails / 100) + tempTotalFixedChargesDataFromChargesDetails

      if (tempVatChargeDataFromChargesDetails != '') {
        this.settlementDetails.vat = this.settlementDetails.charges * (parseFloat(tempVatChargeDataFromChargesDetails.charges) / 100)
      }


    },
    confirm() {
      // this.createSettlementTransactions.push(this.tempMutedData.row.uuid)
      this.skippedData.push(this.tempMutedData.row)
      if (this.tempMutedData.row.transaction_type_id != 6) {

        if((this.tempMutedData.row.transaction_type_id == 11 || this.tempMutedData.row.transaction_type_id == 15) && this.selectedMerchantDetails.id == this.tempMutedData.row.sender_account_id){
          /*the amount is of adjustment so add it */
          let amountToBeAdded =  parseFloat(this.tempMutedData.row.amount) + parseFloat(this.tempMutedData.row.vat) + parseFloat(this.tempMutedData.row.fee)
          this.settlementDetails.paybleAmount = this.settlementDetails.paybleAmount + amountToBeAdded
        }else{
          /*if row is skipped then minus the amount of row from total payable amount*/

          let amountToBeDeduct = this.tempMutedData.row.amount - this.tempMutedData.row.vat - this.tempMutedData.row.fee

          this.settlementDetails.paybleAmount = this.settlementDetails.paybleAmount - amountToBeDeduct
        }




      } else {
        /*the amount is of refund so add it */
        let amountToBeAdded =  parseFloat(this.tempMutedData.row.amount) + parseFloat(this.tempMutedData.row.vat) + parseFloat(this.tempMutedData.row.fee)
        this.settlementDetails.paybleAmount = this.settlementDetails.paybleAmount + amountToBeAdded
      }
      let tempVatChargeDataFromChargesDetails = ''
      let tempTotalPercentChargesDataFromChargesDetails = 0
      let tempTotalFixedChargesDataFromChargesDetails = 0

      Object.values(this.settlementDetails.chargesDetails).forEach(eachChargeDetail => {
        if (eachChargeDetail.charge_type != 'VAT') {
          if (eachChargeDetail.type == 'percent') {
            tempTotalPercentChargesDataFromChargesDetails += parseFloat(eachChargeDetail.charges)
          } else {
            tempTotalFixedChargesDataFromChargesDetails += parseFloat(eachChargeDetail.charges)
          }
        } else {
          /*if charge type is vat then save for later use after the final charge has bee calculated*/
          tempVatChargeDataFromChargesDetails = eachChargeDetail
        }
      })

      this.settlementDetails.charges = this.settlementDetails.paybleAmount * (tempTotalPercentChargesDataFromChargesDetails / 100) + tempTotalFixedChargesDataFromChargesDetails

      if (tempVatChargeDataFromChargesDetails != '') {
        this.settlementDetails.vat = this.settlementDetails.charges * (parseFloat(tempVatChargeDataFromChargesDetails.charges) / 100)
      }


      delete this.tempMutedData.row
      this.mutedData = this.tempMutedData
      this.showConfirmationModal = false

    },
    confirmCreate() {
      this.showModalForConfirmButton = false
      this.createSettlement()
    },
    getTerminalData() {
      if(!this.selectedMerchant || !this.selectedStore){
        return
      }
      this.terminalLoader = true
      this.makeRequest("post", "v1/get-terminal", {userId: this.selectedMerchant.id,storeId:this.selectedStore?this.selectedStore.id:'',status:1}, {}, false,true,[205]).then(
          (callResponse) => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              let responseData = callResponse.response.data.data;
              if (code == 200) {
                if(responseData){
                  this.terminalData = responseData;
                }
                else{
                  this.terminalData = []
                }
                this.setSelectedTerminalValue();
              }
            }
            this.terminalLoader = false
          }
      );
    },
    setSelectedTerminalValue() {


      if (this.selectedTerminal == null && this.terminalData.length > 0) {
        this.selectedTerminal = this.terminalData[0];

      }
      else{
        this.selectedTerminal = null
      }
    },
    getChannelData() {
      this.channelLoader = true
      this.makeRequest("post", "v1/get-channel", {userId: this.selectedMerchant.id,storeId:this.selectedStore?this.selectedStore.id:'',terminalId:this.selectedTerminal?this.selectedTerminal.id:'',status:1}, {}, false,true,[205]).then(
          (callResponse) => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              let responseData = callResponse.response.data.data;
              if (code == 200) {
                if(responseData){
                  this.channelData = responseData;
                }
                else{
                  this.channelData = []
                }
                this.setSelectedChannelValue();
              }
            }
            this.channelLoader = false
          }
      );
    },
    setSelectedChannelValue() {
      if (this.selectedChannel == null && this.channelData.length > 0) {
        this.selectedChannel = this.channelData[0];

      }
      else{
        this.selectedChannel = null
      }
    },
    getPaymentMethods() {
      this.paymentMethodLoader = true
      this.makeRequest("post", "v1/get-payment-method", {independentSettlement: 1, flag: 'active'}, {}, false,true,[205]).then(
          (callResponse) => {
            this.paymentMethodLoader = false
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              let responseData = callResponse.response.data.data;
              if (code == 200) {
                this.paymentMethods = responseData ? responseData : [];
              }
            }
          }
      );
    },
    getMerchantData() {
      this.makeRequest("post", "v1/get-merchants", {flag: 'all'}, {}, false,true,[205]).then(
          (callResponse) => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              let responseData = callResponse.response.data.data;
              if (code == 200) {
                this.MerchantsData = responseData;
                this.setSelectedMerchantValue();
              }
            }
          }
      );
    },
    setSelectedMerchantValue() {


      if (this.selectedMerchant == null && this.MerchantsData.length > 0) {
        this.selectedMerchant = this.MerchantsData[0];
        // this.getMerchantDetailsData(this.selectedMerchant.id)
      }
    },
    getMerchantDetailsData(id) {
      this.makeRequest("post", "v1/detail-merchant", {id: id}, {}, false,true,[205]).then(
          (callResponse) => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              let responseData = callResponse.response.data.data;
              if (code == 200) {
                this.MerchantDetailsData = responseData.accounts ? responseData.accounts : [];
                this.setSelectedMerchantDetailsValue();
              }
            }
          }
      );
    },
    setSelectedMerchantDetailsValue() {

      this.selectedMerchantDetails = this.MerchantDetailsData[0];
      // if (this.selectedMerchantDetails == null && this.MerchantDetailsData.length > 0) {
      //   this.selectedMerchantDetails = this.MerchantDetailsData[0];
      // }
    },
    getFullResponse(response) {
      if (typeof (response.fullResponse) != 'undefined') {
        let data = response.fullResponse
        if (this.settlementDetails.charges == '' && this.settlementDetails.paybleAmount == '' && this.settlementDetails.vat == '') {
          this.settlementDetails.charges = typeof (data.charges) != 'undefined' ? data.charges : this.settlementDetails.charges
          this.settlementDetails.paybleAmount = typeof (data.paybleAmount) != 'undefined' ? data.paybleAmount : this.settlementDetails.paybleAmount
          this.settlementDetails.vat = typeof (data.vat) != 'undefined' ? data.vat : this.settlementDetails.vat
          this.settlementDetails.chargesDetails = typeof (data.chargesDetails) != 'undefined' ? data.chargesDetails : this.settlementDetails.chargesDetails
          this.settlementData = typeof (data.settlementData) != 'undefined' ? data.settlementData : this.settlementData
          this.rollingReserveDetails = typeof (data.rollingReserveDetails) != 'undefined' ? data.rollingReserveDetails:null
        }

        // if(typeof(data.charges) != 'undefined'){
        //
        // }
      }
    },
    generateSettlement() {
      // Store is mandatory when the settlement is generated for a store
      this.storeError = this.settlementForStore && !this.selectedStore
      if (this.storeError) {
        return
      }

      this.tempMutedData = []
      this.createSettlementTransactions = []
      this.skippedData = []
      this.settlementDetails = {
        charges: '',
        paybleAmount: '',
        vat: '',
        chargesDetails: []
      }
      this.settlementData = ''
      this.showSkipped = false

      // this.showTable =false
      // this.filteredData = {userAccountId:13,fromDate:'2021-03-15',toDate:'2021-06-15',type:'aggregate'}}
      this.filteredData = {
        userAccountId: this.selectedMerchantDetails.id,
        // storeId: this.selectedStore?this.selectedStore.id:'',
        // terminalId: this.selectedTerminal?this.selectedTerminal.id:'',
        // Account settlement: no store or channel id. Store settlement: only the store id.
        // Otherwise the selected channel id.
        ...(this.settlementForAccount
            ? {}
            : this.settlementForStore
                ? { storeId: this.selectedStore.id }
                : { channelId: this.selectedChannel ? this.selectedChannel.id : '' }),
        fromDate: this.fromDate,
        toDate: this.toDate,
        settlementForPaymentMethodId: this.selectedPaymentMethod ? this.selectedPaymentMethod.id : null,
        type: 'aggregate',
        perPage: 100
      }
      setTimeout(() => {
        this.url = "v1/get-settlement-transactions"
      }, 1000);


    },
  },
  watch: {
    settlementForStore(val) {
      this.storeError = false
      if (val) {
        // Terminal and channel are hidden for a store settlement, drop any selection
        this.selectedTerminal = null
        this.selectedChannel = null
        this.terminalData = []
        this.channelData = []
      } else if (this.selectedStore) {
        this.getTerminalData()
      }
    },
    selectedStore(val) {
      this.storeError = false
      this.selectedTerminal = null
      if(!val){
        this.terminalData = []
        return
      }
      if (this.settlementForStore) {
        return
      }
      this.getTerminalData()
    },
    selectedMerchant(val) {
      if(val){
        this.getMerchantDetailsData(val.id)
        this.requestParams = JSON.parse(JSON.stringify({userId: val.id}))
      }else{
        this.storeData = []
        this.selectedStore = null
        this.selectedMerchantDetails = null
        this.MerchantDetailsData = []
        this.requestParams = null
      }
    },
    selectedTerminal(val) {
      this.selectedChannel = null
      if(!val){
        this.channelData = []
        return
      }
      this.getChannelData()
    },
  },
}
</script>

